export default {"src":"/_next/static/media/empathize-line.bbf02b8c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};